import AvatarIcon from 'assets/icon/AvatarIcon'
import MenuIcon from 'assets/icon/MenuIcon'
import LogoutButton from 'components/Button/LogoutButton'
import moment from 'moment'

function Navbar({ toggleSidebar }) {
	let pathArray = window.location.pathname.split("/")

	function fLogoutBtnClick(){
		localStorage.removeItem("Token")
		localStorage.removeItem("Username")
		localStorage.removeItem("FirstName")
		localStorage.removeItem("LastName")
		localStorage.removeItem("Email")

		window.location.href = "/login"
	}

   	return (
		<div className={`sticky top-0 bg-white transition-all z-20 w-full flex justify-between items-center py-2 px-4`}>
			<div className='flex items-center gap-4'>
				<button className='block' onClick={toggleSidebar}>
					<MenuIcon className='fill-black w-5' />
				</button>
				<span className='text-lg font-semibold hidden md:block'>Delala Kost & Guest House</span>
			</div>
			<div className='flex gap-3 justify-between items-center'>
				<h1 className='pl-12 sm:pl-0 hidden md:block'>Welcome back, { localStorage.getItem("FirstName") +  " " + localStorage.getItem("LastName") }</h1>
				<button className="rounded hidden sm:block" >
					<AvatarIcon />
				</button>

				<div className='bg-lime-500 px-3 rounded-xl shadow-md'>
					<span className='text-sm'>Today : </span>
					<span className='text-sm'>{moment(new Date()).format("dddd, DD MMM yyyy")}</span>
				</div>

				{/* <button onClick={ () => { window.location.href = "/" }}>
					<span>Home</span>
				</button> */}
				
				<div className="relative flex items-center justify-center">
					<LogoutButton onClick={() => { fLogoutBtnClick() }} />
				</div>
			</div>
		</div>
	)
}

export default Navbar